module.exports = __webpack_public_path__ + "img/img0303.dc7b1c87.png";